import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import styles from './thankyoumessage.module.scss';
import { useReactToPrint } from 'react-to-print';
import PrintSubmissionReport from '../PrintSubmissonReport';

const ecripsologourl = /*preval*/ `${process.env.GATSBY_ASSET_CDN_SITE}/styles/ecri-pso_logo_fc_trimmed.png`;

const ThankYouMessage = ({ onClick, data }: any) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  const handleClick = (e: { preventDefault: (arg0: any) => void }) => {
    e.preventDefault(e);
    onClick(false);
  };

  // Note (401): In TypeScript, if you encounter componentRef.current error such as: Type 'undefined' is not assignable to type 'ReactInstance | null'., add null inside the useRef():
  const componentRef = useRef(null);
  //   const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'PSOEventReport',
  });

  return (
    <div className="page-content">
      <div className="container">
        <div className="col-xs-12">
          <img
            className={styles.ecriPsoLogo}
            src={ecripsologourl}
            alt="ECRI PSO Logo"
          />
          <div className={`page-section ${styles.pageSection}`}>
            <p>
              Thank you for submitting your medication or vaccine related event
              or safety concern to ECRI and the ISMP PSO. We will contact you if
              we have any questions after reviewing the report. If
              you would like to speak to someone about your report or if you
              have any other questions or concerns, please email{' '}
              <a href="mailto:mgaunt@ismp.org">mgaunt@ismp.org</a>.
            </p>

            <div className={styles.actionButtons}>
              <button
                className={`${styles.formButton} accentButton`}
                type="button"
                onClick={handlePrint}
                aria-label="Print your report"
              >
                Print your report
              </button>
              <button
                className={`${styles.formButton} accentButton`}
                type="submit"
                onClick={handleClick}
                aria-label="Submit another report"
              >
                Submit another report
              </button>
              <div className={styles.printSubmissionReportComponent}>
                <PrintSubmissionReport data={data} ref={componentRef} />
              </div>
            </div>
            <div className={styles.actionButtons}>
              <a
                className={styles.actionLink}
                href="https://home.ecri.org/pages/ismp"
                aria-label="Visit ISMP Website"
              >
                <FontAwesomeIcon
                  className={styles.linkIcon}
                  icon={faExternalLinkAlt}
                />
                Visit the ISMP website
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ThankYouMessage.propTypes = {
  onClick: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default ThankYouMessage;
